import React from 'react'

import { RatingList } from './../RatingList'
import { RatingInactiveProps } from './ratingInactive.types'
import * as S from './../../fieldsInactive.styles'

export const RatingInactive = ({ item, ...props }: RatingInactiveProps) => {
    return (
        <S.FieldInactiveWrapper {...props}>
            <S.Header>
                <S.Title>{item.value}</S.Title>

                {item.required && <S.Required>*Required</S.Required>}
            </S.Header>

            <RatingList item={item} />
        </S.FieldInactiveWrapper>
    )
}
